<template>
  <div class="order">
    <div class="allOrder__header">
      <div class="allOrder__header__left">
        <div class="allOrder__header__left__search">
          <i class="adx-ic_search"></i>
          <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
        </div>
        <div class="allOrder__header__left__filter">
          <dropdown-list class="dropdownDoc__item" @selected="selectedProgress" :valueDisplay="selectedOrderStatusValue" :list="progressList" labelButton="All Progress" />
        </div>
        <div class="allOrder__header__left__filter">
          <dropdown-list class="dropdownDoc__item" @selected="selectedStatus" :valueDisplay="selectedChannelValue" :list="statusList" labelButton="All Status" />
        </div>
          <dropdown-2-level v-if="isShowBulkAction" @selected="selectedBulkAction"  :lists="bulkAction" labelButton="Bulk Action"/>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="allOrder__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    
    <adx-table text="Tooltip button" 
      :items.sync="data" 
      :loading.sync="isLoading"
      :isEmpty.sync="isEmpty"
      :titleText="`View Detail`"
      @selected="selected" 
      @setItem="setItem" 
      @selectedCheckbox="selectedCheckbox"
      @selectedRow="selectedRow">
    </adx-table>
    
    <div class="total_order" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Orders</div>
    <adx-pagination
      v-if="!isLoading && !isEmpty"
      @change-page="selectPage"
      :max-page="maxPage"
      :selectedPage="selectedPage"
    />
  </div>
</template>

<script>
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Pagination from '@/components/Pagination'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import Loading from '@/components/Loading/Primary'
import Dropdown2Level from '@/components/Dropdown/Dropdown2Level'
import DropdownList from '@/components/Dropdown/ListDropdown'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { parseErrorGql } from '@/lib/error'
import * as validationLib from '@/lib/validation/'
import { mapGetters } from 'vuex'
import { constants } from 'crypto';
const {
  helpers,
  validate
} = validationLib

export default {
  name: "adx-all-order",
  components: {
    "adx-table": table,
    LabelStatus,
    DropdownList,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-search': DropdownSearch,
    'adx-pagination': Pagination,
    'adx-loading': Loading,
    'dropdown-2-level': Dropdown2Level
  },
  props: {
      
  },
  data() {
    return {
      item: null,
      isUpdate: false,
      menuOption:[{
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": []
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        }],
      admin: null,
      isShowBulkAction:false,
      isInit: true,
      items: [],
      selectedItems:[],
      maxPage: 1,
      selectedPage: 1,
      refetchLoading: false,
      count: 0,
      searchBoxValue: '',
      selectedSortValue: 'first_added',
      selectedOrderStatusValue:'',
      selectedOrderStatusLabel:'',
      selectedChannelValue:'',
      selectedChannelLabel:'',
      selectedCampaignStatus:'',
      selectedCampaignLabel:'',
      selectStatus: '',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      typeNotifications :[
        {
          type: ''
        },
        {
          type: 'warning'
        },
        {
          type: 'new'
        }
      ],
      data: {
        notifications: [],
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text-value"
          },
          {
            title: "COMPANY NAME",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PROGRESS",
            type: "statuslabel"
          },
          {
            title: "STATUS",
            type: "indicatorStatus"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "START DATE",
            type: "date"
          }
        ],
        body: []
      },
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'No Status',
          value: "nostatus"
        },
        {
          id: 2,
          label: 'Verified',
          value: "verified"
        },
        {
          id: 3,
          label: 'Designed',
          value: "designed"
        },
        {
          id: 4,
          label: 'Wrapped',
          value: "wrapped"
        },
      ],
      progressList: [
        {
          id: 99,
          label: 'All Progress',
          value: null
        },
        {
          id: 0,
          item: 'LEAD',
          label: 'Lead',
          value: "lead"
        },
        {
          id: 1,
          item: 'VERIFYING',
          label: 'Verifying',
          value: "verifying",
        },
        {
          id: 2,
          item: 'DESIGNING',
          label: 'Designing',
          value: "designing"
        },
        {
          id: 3,
          item: 'DESIGN APPROVAL',
          label: 'Design Approval',
          value: "designapproval"
        },
        {
          id: 4,
          item: 'PRINTING',
          label: 'Printing',
          value: "printing"
        },
        {
          id: 5,
          item: 'PRINTING APPROVAL',
          label: 'Printing Approval',
          value: "printapproval"
        },
        {
          id: 6,
          item: 'WRAPPING',
          label: 'Wrapping',
          value: "wrapping"
        },
        {
          id: 7,
          item: 'DONE',
          label: 'Done',
          value: "done"
        }
      ],
      bulkAction: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": [],
        }
      ],
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedOrderStatusValue || this.selectedChannelValue) {
        filtered = true
      }
      return filtered
    },
    getFilterParams: function () {
      const params = {
        sort: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
        orderStatus: this.selectedOrderStatusValue || undefined,
        channelStatus: this.selectedChannelValue || undefined,
        campaignStatus: this.selectedCampaignStatus || undefined
      }
      return params
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    isLoading: function(){
      return this.$apollo.loading || this.refetchLoading || false
    },
    ...mapGetters({
      token: 'token',
      user: 'account',
    })
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.$apollo.queries.busOrdersPage.refetch()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.$apollo.queries.busOrdersPage.refetch()
      }
    },
    selectedOrderStatusValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    },
    selectedChannelValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    },
  },
  beforeCreate() {
    
  },
  async created() {
    this.getProgressList()
    if (this.$route.params.isPushed) {
      if (this.$route.params.isPushed === true) {
        this.refetchLoading = true
        await this.$apollo.queries.busOrdersPage.refetch()
        this.refetchLoading = false
      }
    }
  },
  apollo: {
    busOrdersPage: {
      query: require('@/graphql/bus/query/busOrdersPage.gql'),
      variables(){
        return {
          campaignStatus: undefined,
          sort: this.selectedSortValue || undefined,
          search: this.searchBoxValue || undefined,
          orderStatus: this.selectedOrderStatusValue || undefined,
          channelStatus: this.selectedChannelValue || undefined,
          page: this.selectedPage.toString() || "1"
        }
      },
      loadingKey: 'loading',
      errorPolicy: 'all',
      async result(data) {
        const {busOrdersPage} = data.data

        if (busOrdersPage){
          await this.mapData(busOrdersPage)
        }else {
          this.$router.push({ name: `500` })
          this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Something went wrong. Please refresh the page!`,
                  type: 'danger'
                });
        } 
      }
    },
  },
  beforeMount() {

  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.admin = this.user.isStaff
    const { page } = this.$route.query
    if(page){
      this.selectedPage = parseInt(page)
    }
    if(this.admin){
      this.data.menu = this.menuOption
      this.data.checkbox = true
    }
  },
  beforeUpdate() {

  },
  updated() {
    
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async mapData(busOrdersPage){
      let meta = busOrdersPage.meta
      let result = busOrdersPage.busOrders
      this.resetData()
      var datanotif = []
      var body = []
      await result.forEach(res => {
        const progressItems = [
          {
            'status': false,
            'title': 'VERIFIED',
          },
          {
            'status': false,
            'title': 'DESIGNED',
          },
          {
            'status': false,
            'title': 'WRAPPED',
          }
        ]
        let pgIdx = res.status.title + 1
        let statusBaru = ''
        let statusDisplay = this.getStatusDisplay(res.status.titleDisplay)
        let notif = this.typeNotifications[0]
        if (res.notification.is_read == false){
          notif = this.typeNotifications[2]
        } else if (res.alert.is_read == false){
          notif = this.typeNotifications[1]     
        }
          datanotif.push(notif)
        
        let valuesData = [
          { label: res.number, value: res.id},
          { value: res.campaign.companyName },
          { value: res.campaign.title},
          { value: statusDisplay.value, label: statusDisplay.label},
          { status: statusDisplay.status, items: progressItems},
          { value: parseInt(res.campaign.totalPrice) || 0 },
          { value: res.campaign.start},
        ]
        body.push({values:valuesData})
      });
      this.data.body = body
      this.data.notifications = datanotif
      this.maxPage = meta.maxPage
      this.count = meta.count

    },
    resetData(){
      this.data.body = null
      this.data.body = []
    },
    getProgressList(){
      let pglist = []
      this.progressList.forEach( res => {
        if(res.id != 99){ pglist.push(res)}
      })
      this.bulkAction[0].items= pglist
      this.menuOption[0].items = pglist 
    },
    async selected(event, index, id) {
      if (event.items){
        this.refetchLoading = true
        let dataIndex = this.data.body[index]
        let dataDisplay = this.getStatusDisplay(event.items.value)

        let body = { status:dataDisplay.id }
        const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/updateStatusByOrder.gql'),
            variables: {
              id: id.toString(),
              orderStatus: {status:dataDisplay.id}
            }
          }
        );
        if (result.data){
          await this.$apollo.queries.busOrdersPage.refetch()
          this.$notify({
            group: 'saved',
            title: 'Change Status',
            text: 'Change Status Saved',
            type: 'success'
          });
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
          });
        }
        this.refetchLoading = false
      } else {
        const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/mutation/updateNotificationByOrder.gql'),
            variables: {
              id: id,
              orderNotification:{
                is_read:true
              }
            }
          }
        );
        this.$router.push({ name: 'orderdetailexecution', params: { id: id }})
      }
    },     
    selectedCheckbox(selectedItems){
      if(selectedItems.length){
        this.isShowBulkAction = true
      } else{
        this.isShowBulkAction = false
      }
      this.selectedItems = selectedItems
    },     
    async selectedBulkAction(event, index, id){
      this.refetchLoading = true
      let ids = []

      this.selectedItems.forEach(element => {
        ids.push(parseInt(element));
      });
      
      let valueChange = event.items

      const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/updateStatusByOrderBulk.gql'),
            variables: {
              orderStatus: {
                status: valueChange.id,
                listId: ids
              }
            }
          }
        );
        if (result.data){
          await this.$apollo.queries.busOrdersPage.refetch()
          this.refetchLoading = false
          this.$notify({
            group: 'saved',
            title: 'Change Status',
            text: 'Change Status Saved',
            type: 'success'
          })    
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
          });
        }
    },
    selectedProgress(item){
      this.selectedOrderStatusValue = item.value? item.id.toString(): ''
      this.selectedOrderStatusLabel = item.label
    },
    selectedStatus(item){
      this.selectedChannelValue = item.value
      this.selectedChannelLabel = item.label
    },
    setItem(item) {
      this.item = item
    },
    async resetFilter(){
      this.selectedPage = 1
      this.selectedOrderStatusValue = null,
      this.selectedOrderStatusLabel = null,
      this.selectedChannelValue = null,
      this.selectedChannelLabel = null
      await this.$apollo.queries.busOrdersPage.refetch()
    },
    async selectPage(item) {
      this.selectedPage = item
      await this.$apollo.queries.busOrdersPage.refetch()
    },
    async selectedRow(item, index){
      let id = item.values[0].value
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateNotificationByOrder.gql'),
        variables: {
          id: id,
          orderNotification:{
            is_read: true
          }
        }
      });
      this.$router.push({ name: 'orderdetailexecution', params: { id: id }})
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `lead`:
          res = { id: 0, value: 'lead', label: 'LEAD', status: ''}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: ''}
          break
        case `designing`:
          res = { id: 2, value: 'designing', label: 'DESIGNING', status: 'verified'}
          break
        case `designapproval`:
          res = { id: 3, value: 'designapproval', label: 'DESIGN APPROVAL', status: 'verified'}
          break
        case `printing`:
          res = { id: 4, value: 'printing', label: 'PRINTING', status: 'verified'}
          break
        case `printapproval`:
          res = { id:5, value: 'printapproval', label: 'PRINTING APPROVAL', status: 'verified'}
          break
        case `wrapping`:
          res = { id:6, value: 'wrapping', label: 'WRAPPING', status:'designed'}
          break
        case `done`:
          res = { id:7, value: 'done', label: 'DONE', status:'wrapped'}
      }
      return res
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang='scss'>
.order {
  .table {
    table {
      thead {
        tr {
          background-color: #fafafa;
          td {
            span {
              font-size:12px;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            .text {
              font-size: 15px;
              max-width: 130px;
              -webkit-line-clamp: 3;
            }
            .date {
              font-size:15px;
            }
            .money {
              text-align:left;
              span {
                font-size:15px;
              }
            }
          }
          cursor:pointer;
        }
      }
    }
	}
}
.standardInput {
  font-size: 15px
}
</style>
